import React, { useState } from "react"
import { useKonva } from "../context/KonvaContext"
import { StlyedDrawer, StyledBackdrop } from "./Instruction.styled"
import CloseIcon from '@mui/icons-material/Close'
import { IconButton, Stack } from "@mui/material"
import step1Gif from '../assets/step1_gif.gif'
import step2Gif from '../assets/step2_gif.gif'
import step3Gif from '../assets/step3_gif.gif'
import step4Gif from '../assets/step4_gif.gif'
import step5Gif from '../assets/step5_gif.gif'

const instructions = [
    {
        description: 'Select any tool from toolbar',
        gif: step1Gif,
    },
    {
        description: 'Draw the shape you want',
        gif: step2Gif,
    },
    {
        description: 'Click on the shape, enter the dimensions and calculate, select any of the area from suggestion and submit',
        gif: step3Gif,
    },
    {
        description: 'Click the bottom left to check the total turf needed to cover whole area',
        gif: step4Gif,
    },
    {
        description: 'Draw a shape by mistake, undo or redo',
        gif: step5Gif,
    },
]

const Instructions = () => {
    const { isHelpModalOpen, setIsHelpModalOpen } = useKonva()
    const [step, setStep] = useState(0)

    const handleNextClick = () => {
        if (step < instructions.length - 2) {
            setStep(step + 2)
        }
    }

    const handlePreviousClick = () => {
        if (step > 0) {
            setStep(step - 2)
        }
    }

    return (
        <StlyedDrawer
            variant="persistent"
            open={isHelpModalOpen}
            anchor={'right'}
            onClose={() => setIsHelpModalOpen(false)}
            ModalProps={{
                BackdropComponent: StyledBackdrop
            }}
        >
            <div style={{ height: '100%' }}>
                <div className="icon-wrapper">
                    <IconButton onClick={() => setIsHelpModalOpen(false)}>
                        <CloseIcon sx={{ color: '#ffffff' }} />
                    </IconButton>
                </div>
                <Stack py={2}>
                    <div className="drawer-header">
                        <h4>Instructions to use canvas</h4>
                    </div>
                </Stack>
                <Stack direction={'column'} justifyContent={'space-between'} height={'90%'}>
                    <Stack gap={3} overflow={'auto'}>
                        <Stack>
                            <p className="instruction">{`${step + 1}. ${instructions[step].description}.`}</p>
                            <Stack pt={'2em'}>
                                <img src={instructions[step].gif} alt="gif not found" />
                            </Stack>
                        </Stack>
                        {step < instructions.length - 1 && (<Stack>
                            <p className="instruction">{`${step + 2}. ${instructions[step + 1].description}.`}</p>
                            <Stack pt={'2em'}>
                                <img src={instructions[step + 1].gif} alt="gif not found" />
                            </Stack>
                        </Stack>)}
                    </Stack>
                    <Stack direction={'row'} justifyContent={'space-between'} py={2}>
                        <div>
                            <button
                                className="button2"
                                onClick={handlePreviousClick}
                                disabled={!step}
                                style={step === 0 ? { backgroundColor: '#8f7859', cursor: 'default' } : null}
                            >
                                Previous
                            </button>
                        </div>
                        <div>
                            <button
                                className="button2"
                                onClick={handleNextClick}
                                disabled={step >= instructions.length - 2}
                                style={step >= instructions.length - 2 ? { backgroundColor: '#8f7859', cursor: 'default' } : null}
                            >
                                Next
                            </button>
                        </div>
                    </Stack>
                </Stack>
            </div>
        </StlyedDrawer>
    )
}

export default Instructions